<template lang="html">
  <div>logout</div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
